const PORTUGUESE_MOBILE = /^9[123689]\d{7}$/;
const PORTUGUESE_COUNTRY_PREFIX = /^(00351|351)/;
const NATIONAL_NUMBER_LENGTH = 9;

export const INVALID_MBWAY_PHONE_MESSAGE = "Indique um número de telemóvel português (9 dígitos, começa por 9).";

type OrderWithClientPhone = {
    treatment?: { id?: number; client?: { user_id?: { phone?: string | null } | null } | null } | null;
    client_id?: { user_id?: { phone?: string | null } | null } | null;
};

export const readMbwayPrefillSources = (order: OrderWithClientPhone) => {
    const clientUser = order.treatment ? order.treatment.client?.user_id : order.client_id?.user_id;
    const prefillSources = { clientPhone: clientUser?.phone ?? null, treatmentId: order.treatment?.id ?? null };
    return prefillSources;
};

export const normalizePortugueseMobile = (value: string | null) => {
    const digits = String(value ?? "").replace(/\D/g, "");
    const nationalDigits = digits.length > NATIONAL_NUMBER_LENGTH ? digits.replace(PORTUGUESE_COUNTRY_PREFIX, "") : digits;
    const mobile = PORTUGUESE_MOBILE.test(nationalDigits) ? nationalDigits : null;
    return mobile;
};
